function TermsSeller() {
    return (
        <div className="terms-container">
            <h2>BIG CIRCLE AUCTIONS LLC<br />TERMS AND CONDITIONS AGREEMENT (SELLER)</h2>

            <p>
                As a seller you agree to the terms and conditions below, in which Big Circle Auctions (BCA) operates
                under. All data is kept on per auction that a seller offers, and the end of each auction is determined
                by the appetite for prospective bidding that is to occur.
            </p>

            <ul className="terms-list">
                <li>I bear full responsibility for any taxable event...</li>
                <li>I bear full responsibility to give access with reasonable notice.</li>
                <li>BCA does not guarantee sale price.</li>
                <li>Submission fee is not refundable if full sale price not met.</li>
                <li>Closing may take up to 45 days.</li>
                <li>BCA may market item digitally and on-site.</li>
                <li>Seller receives 20% payout over 60 months if bidder chooses reward.</li>
                <li>Minimum calculus is proprietary.</li>
                <li>BCA controls rounds to allow fair advancement.</li>
                <li>All calculations are proprietary.</li>
                <li>Chargebacks or wrongdoing = permanent ban.</li>
                <li>100% refund before posting, 50% after posting.</li>
                <li>No refund once auction is live.</li>
                <li>Disputes handled by 6-member panel with attorney tie-break.</li>
            </ul>
        </div>
    );
}

export default TermsSeller;
